export default "__VITE_ASSET__aeb81891__"